<template>
  <div class="page-contact">
    <b-overlay
      :show="loading"
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
    </b-overlay>

    <div class="st-card">
      <div
        class="st-card-glow"
        aria-hidden="true"
      />
      <div class="st-head">
        <span class="st-icon">
          <feather-icon
            icon="MailIcon"
            size="20"
          />
        </span>
        <div>
          <h2 class="st-title">
            {{ $t('pages.contactUs.title') }}
          </h2>
          <p class="st-subtitle">
            {{ $t('pages.contactUs.description') }}
          </p>
        </div>
      </div>

      <div class="st-body">
        <!-- Iletisim bilgileri -->
        <div class="st-info">
          <div class="st-info-item">
            <span class="st-info-icon">
              <feather-icon
                icon="BriefcaseIcon"
                size="18"
              />
            </span>
            <div>
              <h3>ARASANA LTD.ŞTİ.</h3>
              <address>
                Dikilitas Mah. Hakki Yeten Cad. Selenium Plaza No:10/I K: 5&amp;6 34349 Besiktas / İSTANBUL
              </address>
            </div>
          </div>
          <div class="st-info-item">
            <span class="st-info-icon">
              <feather-icon
                icon="AtSignIcon"
                size="18"
              />
            </span>
            <p>{{ $t('pages.contactUs.description2') }}</p>
          </div>
        </div>

        <!-- Form -->
        <validation-observer
          ref="form"
          #default="{invalid}"
        >
          <b-form
            class="st-form"
            @submit.prevent="send"
          >
            <div class="st-field">
              <label for="email">{{ $t('Email') }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                vid="email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  name="email"
                  class="st-input"
                  :placeholder="$t('Email')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="st-field">
              <label for="message">{{ $t('Your message') }}</label>
              <validation-provider
                #default="{ errors }"
                :name="$t('Your message')"
                vid="message"
                rules="required"
              >
                <b-form-textarea
                  id="message"
                  v-model="message"
                  class="st-input st-textarea"
                  :disabled="loading"
                  :placeholder="$t('Your message')"
                  rows="5"
                  max-rows="8"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <button
              type="submit"
              class="st-btn"
              :disabled="loading || invalid"
            >
              <b-spinner
                v-if="loading"
                small
              />
              <feather-icon
                v-else
                icon="SendIcon"
                size="16"
              />
              {{ $t('Send') }}
            </button>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BCardText, BCardTitle, BCol, BForm, BFormGroup, BFormInput, BFormTextarea, BOverlay, BRow, BSpinner,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError, showNotify } from '@/helpers/helpers'

export default {
  components: {
    BButton,
    BCardText,
    BCardTitle,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BFormTextarea,
    BOverlay,
    BRow,
    BSpinner,

    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      country: null,
      email: '',
      loading: false,
      message: '',
      open: false,
      phone: '',
      valid: true,
      // valid: false,
    }
  },
  created () {
    this.email = this.$store.getters['auth/userEmail']
    this.phone = this.$store.getters['auth/userPhoneNumber']
  },
  computed: {
    phoneWithCountryCode () {
      return this.country && this.phoneWithCountryCode()
          ? '+' + this.country.dialCode + this.phone.replace(/ /g, "")
          : (this.phone ? this.phone.replace(/ /g, "") : '')
    }
  },
  methods: {
    countryChanged (country) {
      this.country = country
    },
    onDropdownOpen (open) {
      this.open = open
    },
    phoneValidate(status) {
      // this.valid = status ? status.valid : false
      // this.$refs.form.reset()
    },
    send() {
      if (!this.valid) {
        this.$refs.form.setErrors({
          phone: this.$t('Check your phone number')
        })
        return false
      }
      this.$refs.form.validate().then(success => {
        if (success) {
          // Formu gönder
          this.loading = true
          const data = {
            phoneNumber: this.phoneWithCountryCode,
            email: this.email,
            body: this.message,
          }
          useJwt.support(data)
              .then(response => {
                showNotify(this.$toast, this.$t('Your message has been sent'), 'success')
                this.email = this.$store.getters['auth/userEmail']
                this.message = ''
                this.phone = this.$store.getters['auth/userPhoneNumber']
                this.$refs.form.reset()
              })
              .catch(error => {
                throwDefaultError(this.$toast, error)
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    },
  }
}
</script>


<style lang="scss" scoped>
.page-contact {
  margin: 0 -25px;
}

.st-card {
  position: relative;
  overflow: hidden;
  background: rgba(32, 22, 72, 0.72);
  border: 1px solid rgba(150, 110, 255, 0.28);
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(6, 2, 24, 0.45);
  padding: 26px 30px 30px;
}

.st-card-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(234, 3, 178, 0.25), transparent 70%);
  pointer-events: none;
}

.st-head {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 22px;
  border-bottom: 1px solid rgba(150, 110, 255, 0.2);
}

.st-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #ff4fa8, #c026d3);
  flex-shrink: 0;
}

.st-title {
  color: #fff !important;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
}

.st-subtitle {
  color: rgba(226, 220, 255, 0.75);
  font-size: 14px;
  margin: 0;
}

.st-body {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 28px;
}

.st-info {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.st-info-item {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(14, 10, 40, 0.45);
  border: 1px solid rgba(150, 110, 255, 0.2);

  h3 {
    color: #fff !important;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 6px;
  }

  address,
  p {
    color: rgba(236, 232, 255, 0.85);
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
  }
}

.st-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #c4b5fd;
  background: rgba(139, 92, 246, 0.2);
}

.st-field {
  margin-bottom: 16px;

  label {
    display: block;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 6px;
  }
}

.st-input {
  height: 44px;
  background: rgba(14, 10, 40, 0.55) !important;
  border: 1px solid rgba(170, 140, 255, 0.28) !important;
  border-radius: 12px !important;
  color: #fff !important;
  box-shadow: none !important;

  &::placeholder {
    color: rgba(226, 220, 255, 0.45);
  }

  &:focus {
    border-color: #a855f7 !important;
    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.2) !important;
  }
}

.st-textarea {
  height: auto;
  padding: 12px 14px;
}

.st-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 12px;
  padding: 12px 18px;
  font-weight: 600;
  font-size: 15px;
  color: #fff;
  background: linear-gradient(135deg, #8b5cf6, #a855f7);
  box-shadow: 0 6px 18px rgba(139, 92, 246, 0.35);
  cursor: pointer;

  &:hover:not(:disabled) { filter: brightness(1.1); }
  &:disabled { opacity: .55; cursor: not-allowed; }
}

@media (max-width: 991px) {
  .st-body { grid-template-columns: 1fr; }
}

@media (max-width: 575px) {
  .st-card { padding: 20px 18px; }
}
</style>
